import React, { useContext, useState, useEffect } from "react";
import {
  Stack,
  Box,
  Grid2 as Grid,
  TextField,
  Typography,
  Button,
  IconButton,
  FormControl,
  Select,
  MenuItem,
  InputAdornment,
  Tooltip,
  Avatar,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import "./deleteform.scss";
// icon
import { BiMinusCircle } from "react-icons/bi";

// src
import deletePic from "../../Assets/delete.png";
import { AuthContext } from "../../Context/AuthContext";
import { translateLauguage } from "../../Function/Translate";

export default function DeleteForm({
  open,
  handleClose,
  confirmVal,
  title,
  handleDelete,
}) {
  // Change Language
  const { language } = React.useContext(AuthContext);
  const { t } = translateLauguage(language);

  const [valueVoid, setValueVoid] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setValueVoid("");
  }, [open]);

  return (
    <Dialog
      open={open}
      className="delete-dialog-container"
      fullWidth
      maxWidth="xs"
    >
      <DialogTitle sx={{ padding: "10px 15px 10px 20px " }}>
        <Stack direction="row" justifyContent="space-between">
          <Stack direction="column" justifyContent="center">
            <Typography
              className={language === "en" ? "dialog-title" : "dialog-title-kh"}
            >
              {t(title)}
            </Typography>
          </Stack>
          <Stack direction="column" justifyContent="center">
            <IconButton onClick={handleClose}>
              <BiMinusCircle className="close-icon" />
            </IconButton>
          </Stack>
        </Stack>
      </DialogTitle>
      <DialogContent dividers>
        <Grid container>
          <Grid size={{ xs: 3 }}>
            <img src={deletePic} alt="deletePic" style={{ width: "80px" }} />
          </Grid>
          <Grid size={{ xs: 9 }}>
            <Stack
              direction="column"
              justifyContent="center"
              alignItems="center"
              height="100%"
            >
              <Typography className={language === "en" ? "text" : "text-kh"}>
                {t("do_you_want_to_delete_this_data")}
              </Typography>
            </Stack>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Box className="delete-btn-container">
          <Grid container>
            <Grid size={{ xs: 12 }}>
              <Button
                className={language === "kh" ? "btn-delete-kh" : "btn-delete"}
                fullWidth
                onClick={handleDelete}
              >
                {t("btn-delete")}
              </Button>
            </Grid>
          </Grid>
        </Box>
      </DialogActions>
    </Dialog>
  );
}
